import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authApi } from '../features/auth/authApi';
import { toast } from 'sonner';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!identifier.trim()) return;

    setIsSubmitting(true);
    try {
      await authApi.forgotPassword({ identifier });
      setSuccess(true);
      toast.success('Se o usuário existir, um link foi enviado.');
    } catch (err: any) {
      toast.error(err.message || 'Erro ao solicitar recuperação.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <header className="login-header">
          <h1>Recuperar Senha</h1>
          <p>Informe seu e-mail de acesso</p>
        </header>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ marginBottom: '1rem', color: 'var(--success)' }}>
              Um link de recuperação foi enviado para o e-mail ou WhatsApp cadastrado. Verifique sua caixa de entrada e spam.
            </p>
            <button className="btn-primary" onClick={() => navigate('/login')}>
              Voltar ao Login
            </button>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="identifier">E-mail ou Usuário</label>
              <input
                id="identifier"
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="Ex: admin@empresa.com"
                disabled={isSubmitting}
                autoFocus
                required
              />
            </div>
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Enviando...' : 'Enviar Link de Recuperação'}
            </button>
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/login" style={{ color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.9rem' }}>
                Voltar para o login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
